import { reactive } from 'vue';

export function useCookiePreferences() {
  const state = reactive({
    showBanner: true,
    showPreferences: false,
    preferences: {
      analytics: false,
      marketing: false,
      necessary: true, // Toujours activé
    },
  });

  function acceptAllCookies() {
    const now = new Date().getTime();
    const expirationDate = now + 365 * 24 * 60 * 60 * 1000; // 1 an en ms

    state.preferences.analytics = true;
    state.preferences.marketing = true;

    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', expirationDate.toString());
    localStorage.setItem('cookiePreferences', JSON.stringify(state.preferences));

    state.showBanner = false;
  }

  function managePreferences() {
    state.showPreferences = true;
    console.log('Gestion des préférences ouverte:', state.preferences);
  }

  // Ajout du paramètre preferences
  function savePreferences(preferences) {
    state.preferences = preferences;
    const now = new Date().getTime();
    const expirationDate = now + 365 * 24 * 60 * 60 * 1000;

    localStorage.setItem('cookiePreferences', JSON.stringify(state.preferences));
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', expirationDate.toString());

    state.showPreferences = false;
    state.showBanner = false;

    console.log('Préférences enregistrées et bannière masquée:', state.preferences);
  }

  function closePreferences() {
    state.showPreferences = false;
  }

  function loadPreferences() {
    const savedPreferences = localStorage.getItem('cookiePreferences');
    if (savedPreferences) {
      state.preferences = JSON.parse(savedPreferences);
    }
    console.log('Préférences chargées:', state.preferences);
  }

  function checkConsent() {
    const consent = localStorage.getItem('cookieConsent');
    const consentDate = localStorage.getItem('cookieConsentDate');

    if (consent === 'accepted' && consentDate) {
      const now = new Date().getTime();
      const oneYear = 365 * 24 * 60 * 60 * 1000; // en ms
      const consentTimestamp = parseInt(consentDate, 10);

      if ((consentTimestamp - now) > 0) {
        // Consentement toujours valide (date d'expiration > maintenant)
        state.showBanner = false;
        loadPreferences();
        return;
      }
    }

    // Pas de consentement valide, on affiche la bannière
    state.showBanner = true;
    console.log('Consentement manquant ou expiré:', consent);
  }

  // Appel au démarrage
  checkConsent();

  return {
    state,
    acceptAllCookies,
    managePreferences,
    savePreferences,
    closePreferences,
  };
}
